const embed = document.getElementById('storepoint-container')

const fn = {
  init: () => {
    const urlParams = new URLSearchParams(window.location.search)
    const zip = urlParams.get('zip')

    if (zip) {
      fn.setupObserver(zip)
    }
  },

  setupObserver: (zip) => {
    const targetNode = embed
    const config = { childList: true }

    const callback = function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const zipField = embed.querySelector('#storepoint-searchbar')

          if (zipField) {
            const form = zipField.closest('form')

            setTimeout(() => {
              zipField.value = zip
            }, 500)

            observer.disconnect()
          }
        }
      }
    }

    const observer = new MutationObserver(callback)

    observer.observe(targetNode, config)
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-wheretobuypage'),
  run: fn.init,
}
